export const ARBITRATION_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const

export type ArbitrationStatus = (typeof ARBITRATION_STATUS)[keyof typeof ARBITRATION_STATUS]

export const ARBITRATION_STATUS_LABELS: Record<ArbitrationStatus, string> = {
  [ARBITRATION_STATUS.PENDING]: 'En attente',
  [ARBITRATION_STATUS.APPROVED]: 'Approuvé',
  [ARBITRATION_STATUS.REJECTED]: 'Rejeté',
}
